/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_wt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. A US (short) ton is 2,000 pounds (about 907 kg), while a metric tonne is 1,000 kilograms (about 2,204.6 pounds) — roughly 10% heavier. A UK 'long ton' is different again, at 2,240 pounds. Always check which one a shipping or freight document is referring to.`)
};

const es_uc_wt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Una tonelada estadounidense (corta) es 2,000 libras (aproximadamente 907 kg), mientras que una tonelada métrica es 1,000 kilogramos (aproximadamente 2,204.6 libras) — aproximadamente 10% más pesada. Una tonelada larga del Reino Unido es diferente de nuevo, en 2,240 libras. Siempre verifica a cuál se refiere un documento de envío o carga.`)
};

const de_uc_wt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Eine US-Tonne (short ton) sind 2,000 Pfund (etwa 907 kg), während eine metrische Tonne 1,000 Kilogramm (etwa 2,204.6 Pfund) sind — rund 10% schwerer. Eine britische 'long ton' ist noch einmal anders, nämlich 2,240 Pfund. Prüfen Sie bei Versand- oder Frachtdokumenten immer, welche gemeint ist.`)
};

const nl_uc_wt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Een Amerikaanse (korte) ton is 2.000 pond (ongeveer 907 kg), terwijl een metrieke tonne 1.000 kilogram is (ongeveer 2.204,6 pond) — ongeveer 10% zwaarder. Een Britse 'lange ton' is weer anders, op 2.240 pond. Controleer altijd welke ton een zend- of vrachtdocument gebruikt.`)
};

const fr_uc_wt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Une tonne américaine (short ton) est 2 000 livres (environ 907 kg), tandis qu'une tonne métrique est 1 000 kilogrammes (environ 2 204,6 livres) — environ 10 % plus lourde. Une 'long ton' britannique est différente à nouveau, à 2 240 livres. Vérifiez toujours laquelle un document d'expédition ou de fret se réfère.`)
};

const it_uc_wt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Una tonnellata USA (short ton) è 2.000 libbre (circa 907 kg), mentre una tonnellata metrica è 1.000 chilogrammi (circa 2.204,6 libbre) — circa il 10% più pesante. Una 'long ton' britannica è diversa di nuovo, a 2.240 libbre. Controlla sempre a quale si riferisce un documento di spedizione o trasporto merci.`)
};

const pt_br2_uc_wt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Uma tonelada US (curta) é 2.000 libras (cerca de 907 kg), enquanto uma tonelada métrica é 1.000 quilogramas (cerca de 2.204,6 libras) — aproximadamente 10% mais pesada. Uma 'tonelada longa' do Reino Unido é diferente novamente, em 2.240 libras. Sempre verifique qual delas um documento de envio ou frete se refere.`)
};

const pt_uc_wt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Uma tonelada (curta) americana é 2000 libras (cerca de 907 kg), enquanto uma tonelada métrica é 1000 quilogramas (cerca de 2204,6 libras) — aproximadamente 10% mais pesada. Uma tonelada longa britânica é diferente novamente, com 2240 libras. Verifique sempre qual é a que um documento de envio ou carga refere.`)
};

const ja_uc_wt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。米国(ショート)トンは2,000ポンド(約907 kg)で、メートルトンは1,000キログラム(約2,204.6ポンド) — 約10%重いです。英国の「ロングトン」は別で、2,240ポンドです。常に配送または運送文書がどちらを参照しているかを確認します。`)
};

const zh_uc_wt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_wt_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_wt_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_wt_faq2_a", locale)
	if (locale === "en") return en_uc_wt_faq2_a(inputs)
	if (locale === "es") return es_uc_wt_faq2_a(inputs)
	if (locale === "de") return de_uc_wt_faq2_a(inputs)
	if (locale === "nl") return nl_uc_wt_faq2_a(inputs)
	if (locale === "fr") return fr_uc_wt_faq2_a(inputs)
	if (locale === "it") return it_uc_wt_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_wt_faq2_a(inputs)
	if (locale === "pt") return pt_uc_wt_faq2_a(inputs)
	if (locale === "ja") return ja_uc_wt_faq2_a(inputs)
	return zh_uc_wt_faq2_a(inputs)
};